/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import GlobalSettings from '@/model/global/GlobalSettings'

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import StringEntity from '@/model/dataLayer/api/common/StringEntity'
import i18n from '@/i18n'
import { defaultLanguage } from '@/model/global/DefaultLanguage'
import { booleanOptions } from '@/model/dataLayer/api/dish/Dish'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    form: false,
    header: false
  },
  _langsname: {
    displayName: 'name',
    form: false
  },
  langs: {
    displayName: 'name',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: i18n.t('attributeGroupNames'),
      default: defaultLanguage(),
      childLabelKey: 'lang',
      type: {}
    },
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toLowerCase() === GlobalSettings.getLang().toLowerCase()
      },
      displayChild: (key) => {
        return key === 'name'
      }
    },
    childKey: ['name'],
    labelKey: 'lang',
    children: [StringEntity, StringEntity, StringEntity],
    header: false
  },
  required: {
    displayName: 'required',
    type: IKDataEntity.Types.Boolean
  },
  multiSelect: {
    type: IKDataEntity.Types.Boolean
  },
  maxCount: {
    type: IKDataEntity.Types.Integer,
    formConfig: {
      required: false,
      default: -1
    }
  },
  attrubuteCount: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  asTeaMakerAttribute: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => {
          return booleanOptions
        },
        itemText: 'label',
        itemValue: 'value'
      },
      required: false,
      default: 0
    },
    header: false
  }
  // sort: {
  //   type: IKDataEntity.Types.Integer,
  //   formConfig: {
  //     default: 20,
  //   },
  // },
}
const config = {
  load: async function (filter) {
    return (await hillo.get('Category.php', {
      op: 'showAttributeGroup',
      lang: GlobalSettings.getLang(),
      ...filter
    })).content
  },
  add: async function (item) {
    item.required = item.required ? 1 : 0
    item.multiSelect = item.multiSelect ? 1 : 0
    item.langs = JSON.stringify(item.langs)

    return (await hillo.postWithUploadFile('Category.php?op=addAttributeGroup', {
      printTitle: '',
      name: '',
      ...item
    }, {
      showLoading: true
    })).content
  },
  edit: function (item) {
    item.langs = JSON.stringify(item.langs)
    return hillo.postWithUploadFile('Category.php?op=updateAttributeGroup', item, {
      showLoading: true
    })
  },
  remove: function (id) {
    return hillo.post('Category.php?op=deleteAttributeGroup', { id })
  },
  hasDetail: function () {
    return {
      model: () => import('@/model/dataLayer/api/dish/Attribute'),
      refKey: 'attributeGroupId'
    }
  }
}

export default IKDataEntity.ModelFactory(entity, config)
